export default "__VITE_ASSET__DUC9RjzZ__"